import { Superscript } from './superscript.js'

export * from './superscript.js'

export default Superscript
